<template>
  <div class="page">
    <h3 class="title">{{ $t('m.common-problem') }}</h3>
    <div class="fc-bg-fff ask-list">
      <p class="fc-pad-b-min">{{$t('m.whether-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-whether-account')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.no-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-no-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-money')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-time')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-shot')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.recharge-wrong')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-recharge-wrong')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.refund')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-refund')}}</p>
    </div>
  </div>
</template>
<script>
import { getLanguage } from '../tools/utils'
  export default {
    name: 'asks',
    data() {
      return {
        language: ''
      }
    },
    watch: {

    },
    filters: {

    },
    mounted() {
      this.getLang();
      // this.textSize();
    },
    created() {

    },
    methods: {
      //字体大小
      textSize() {
        ! function(a) {
          function b() {
            var b = g.getBoundingClientRect().width;
            a.rem = (b / 7.5 > 100 ? 100 : (b / 7.5 < 300 / 7.5 ? 300 / 7.5 : b / 7.5)), g.style.fontSize = a.rem +
              "px"
            //a.rem = (b / 7.5), g.style.fontSize = a.rem + "px"
          }
          var g = a.document.documentElement,
            e;
          a.addEventListener("resize", function() {
            clearTimeout(e), e = setTimeout(b, 300)
          }, !1), a.addEventListener("pageshow", function(a) {
            a.persisted && (clearTimeout(e), e = setTimeout(b, 300))
          }, !1), b()
        }(window);
      },
      getLang() {
        this.language = getLanguage();
        var box = document.getElementById("app");
        // let language = navigator.language || navigator.browserLanguage;
        let language = this.language;
        console.log(language, '----sdfadf')
        if (language == 'ar') {
          box.style.direction = 'rtl';
        } else {
          box.style.direction = 'ltr';
        }
      },

    },

  }
</script>

<style scoped>
  @import url("../assets/css/common.css");
  .page {
    background: #FFFFFF;
    line-height: .48rem;
    color: #262626;
  }

  .page .title {
    height: 1rem;
    line-height: 1rem;
    padding: 0 0.3rem;
    background: #F5F5F5;
    color: #595959;
    font-size: 0.36rem;
    font-weight: 600;
  }

  .ask-list {
    color: #262626;
    font-size: 0.34rem;
    padding: 0.4rem 0.3rem 1.33rem 0.3rem;
  }

  .ask-list .fc-color-gray-light {
    color: #8C8C8C;
    line-height: 0.36rem;
    font-size: 0.3rem;
  }

  .fc-pad-b-min {
    line-height: 0.42rem;
    margin-bottom: 0.1rem !important;
    padding-bottom: 0 !important;
    font-size: 0.34rem;
    color: #262626;
  }

  .hr-line {
    border: 0;
    //margin: .18rem 0;
    margin-bottom: 0.6rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/asks.vue